import React from 'react';
import './Logo.css';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'medium', showText = true, className = '' }) => {
  const sizeMap = {
    small: { icon: 40, text: 14 },
    medium: { icon: 60, text: 18 },
    large: { icon: 80, text: 24 }
  };

  const { icon: iconSize, text: textSize } = sizeMap[size];

  return (
    <div className={`logo-container ${className}`}>
      <svg 
        width={iconSize} 
        height={iconSize} 
        viewBox="0 0 100 100" 
        className="logo-icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer white ring */}
        <circle cx="50" cy="50" r="49" fill="white" stroke="#1e3a8a" strokeWidth="2"/>
        
        {/* Dark blue ring */}
        <circle cx="50" cy="50" r="46" fill="none" stroke="#1e3a8a" strokeWidth="3"/>
        
        {/* Gradient background */}
        <defs>
          <linearGradient id="logoGradient" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#1e3a8a" />
            <stop offset="100%" stopColor="#0ea5e9" />
          </linearGradient>
        </defs>
        <circle cx="50" cy="50" r="43" fill="url(#logoGradient)"/>
        
        {/* Upward trending chart line */}
        <path
          d="M 20 70 L 30 65 L 40 55 L 50 45 L 60 35 L 70 25 L 75 20"
          stroke="#84cc16"
          strokeWidth="4"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* Arrow at the end */}
        <path
          d="M 70 25 L 75 20 L 72 22 L 75 20 L 72 18"
          stroke="#84cc16"
          strokeWidth="3"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* Dollar sign */}
        <text
          x="35"
          y="60"
          fontSize="28"
          fill="#84cc16"
          fontWeight="bold"
          fontFamily="Arial, sans-serif"
        >
          $
        </text>
      </svg>
      
      {showText && (
        <div className="logo-text" style={{ fontSize: `${textSize}px` }}>
          <span className="logo-text-spend">Spend</span>
          <span className="logo-text-sense">Sense</span>
        </div>
      )}
    </div>
  );
};

export default Logo;

